import { DSPostShortWithAuthor, DSRootCategoryHero } from 'shared-definitions/types'

export function rootCategoryHerosMapper(posts: DSPostShortWithAuthor[]): DSRootCategoryHero[] {
  const first = posts.slice(0, 4)
  const second = posts.slice(4, 8)
  const result: DSRootCategoryHero[] = []

  if (first.length === 4) {
    result.push({
      main: first[0],
      side: first.slice(1),
    })
  }
  if (second.length === 4) {
    result.push({
      main: second[0],
      side: second.slice(1),
    })
  }

  return result
}
